// components/Reports/reportReasons.js

export const REPORT_REASONS = [
  { value: '욕설', label: '욕설' },
  { value: '광고', label: '광고/홍보' },
  { value: '도배', label: '도배' },
  { value: '기타', label: '기타(직접입력)' },
];